<div class="heading-section">
  <div class="page-title">
    Notifications
    @if (!isSmeUser) {
      <button
        id="tour-notification-settings"
        class="settings-icon-btn"
        [class.rotating]="showNotificationSettings"
        (click)="openNotificationSettings()"
        title="Notification Settings"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
          width="20"
          height="20"
          style="fill: #666"
        >
          <path
            d="M259.1 73.5C262.1 58.7 275.2 48 290.4 48L350.2 48C365.4 48 378.5 58.7 381.5 73.5L396 143.5C410.1 149.5 423.3 157.2 435.3 166.3L503.1 143.8C517.5 139 533.3 145 540.9 158.2L570.8 210C578.4 223.2 575.7 239.8 564.3 249.9L511 297.3C511.9 304.7 512.3 312.3 512.3 320C512.3 327.7 511.8 335.3 511 342.7L564.4 390.2C575.8 400.3 578.4 417 570.9 430.1L541 481.9C533.4 495 517.6 501.1 503.2 496.3L435.4 473.8C423.3 482.9 410.1 490.5 396.1 496.6L381.7 566.5C378.6 581.4 365.5 592 350.4 592L290.6 592C275.4 592 262.3 581.3 259.3 566.5L244.9 496.6C230.8 490.6 217.7 482.9 205.6 473.8L137.5 496.3C123.1 501.1 107.3 495.1 99.7 481.9L69.8 430.1C62.2 416.9 64.9 400.3 76.3 390.2L129.7 342.7C128.8 335.3 128.4 327.7 128.4 320C128.4 312.3 128.9 304.7 129.7 297.3L76.3 249.8C64.9 239.7 62.3 223 69.8 209.9L99.7 158.1C107.3 144.9 123.1 138.9 137.5 143.7L205.3 166.2C217.4 157.1 230.6 149.5 244.6 143.4L259.1 73.5zM320.3 400C364.5 399.8 400.2 363.9 400 319.7C399.8 275.5 363.9 239.8 319.7 240C275.5 240.2 239.8 276.1 240 320.3C240.2 364.5 276.1 400.2 320.3 400z"
          />
        </svg>
      </button>
    }
  </div>

  @if (!loading && notifications.length > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'notifications'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

@if (!loading) {
  <div class="notifications-wrapper">
    <div class="left-section">
      @if (notifications.length > 0) {
        <div
          class="section-wrapper"
          [class.has-notification-dot]="hasUnreadNotification"
        >
          <div class="all-section">
            <label class="checkbox-container all-checkbox">
              <input
                id="tour-notification-checkmark"
                type="checkbox"
                [(ngModel)]="allChecked"
                (change)="onAllCheckBoxChange()"
              />
              <span class="checkmark"></span>
              <span class="label-text">All</span>
            </label>
            @if (selectedNotifications.length > 0) {
              <div class="right-section-buttons">
                @if (hasOnlyUnreadSelected) {
                  <a
                    id="tour-notification-mark-read"
                    href="javascript:void(0)"
                    class="mark-read-btn"
                    (click)="markSelectedAsRead()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                      style="
                        height: 15px;
                        width: 15px;
                        fill: #fff;
                        margin-right: 5px;
                      "
                    >
                      <path
                        d="M128.4 239.8L320 97.9L511.6 239.8L353.5 357C343.8 364.2 332.1 368 320 368C307.9 368 296.2 364.1 286.5 357L128.4 239.8zM320 32C307.9 32 296.2 35.9 286.5 43L89.9 188.7C73.6 200.8 64 219.8 64 240.1L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 240.1C576 219.8 566.4 200.7 550.1 188.7L353.5 43C343.8 35.8 332.1 32 320 32z"
                      />
                    </svg>
                    Mark as Read
                  </a>
                }
                @if (hasOnlyReadSelected) {
                  <a
                    id="tour-notification-mark-unread"
                    href="javascript:void(0)"
                    class="mark-unread-btn"
                    (click)="markSelectedAsUnread()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                      style="
                        height: 15px;
                        width: 15px;
                        fill: #fff;
                        margin-right: 5px;
                      "
                    >
                      <path
                        d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"
                      />
                    </svg>
                    Mark as Unread
                  </a>
                }
                @if (hasMixedReadStatusSelected) {
                  <a
                    id="tour-notification-mark-read"
                    href="javascript:void(0)"
                    class="mark-read-btn"
                    (click)="markSelectedAsRead()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                      style="
                        height: 15px;
                        width: 15px;
                        fill: #fff;
                        margin-right: 5px;
                      "
                    >
                      <path
                        d="M128.4 239.8L320 97.9L511.6 239.8L353.5 357C343.8 364.2 332.1 368 320 368C307.9 368 296.2 364.1 286.5 357L128.4 239.8zM320 32C307.9 32 296.2 35.9 286.5 43L89.9 188.7C73.6 200.8 64 219.8 64 240.1L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 240.1C576 219.8 566.4 200.7 550.1 188.7L353.5 43C343.8 35.8 332.1 32 320 32z"
                      />
                    </svg>
                    Mark as Read
                  </a>
                  <a
                    id="tour-notification-mark-unread"
                    href="javascript:void(0)"
                    class="mark-unread-btn"
                    (click)="markSelectedAsUnread()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                      style="
                        height: 15px;
                        width: 15px;
                        fill: #fff;
                        margin-right: 5px;
                      "
                    >
                      <path
                        d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"
                      />
                    </svg>
                    Mark as Unread
                  </a>
                }
                <a
                  id="tour-notification-clear"
                  href="javascript:void(0)"
                  class="clear-btn"
                  (click)="clearSelectedNotifications()"
                >
                  <app-svg-icon
                    [iconName]="'delete.svg'"
                    [height]="'12px'"
                    [width]="'12px'"
                    [style.fill]="'#fff'"
                    [style.padding-right]="'5px'"
                  ></app-svg-icon>
                  Clear
                </a>
              </div>
            }
          </div>

          <div class="results-wrapper">
            @for (notification of notifications; let i = $index; track $index) {
              <div
                class="notification-item"
                [class.unread]="!notification.is_read"
                [id]="'tour-notification-item-' + i"
              >
                <label class="notification-checkbox">
                  <input
                    type="checkbox"
                    [checked]="
                      allChecked || selectedNotifications.includes(notification)
                    "
                    (change)="onNotificationChecked(notification, $event)"
                    (click)="$event.stopPropagation()"
                  />
                  <span class="checkmark"></span>
                </label>

                <div
                  class="notification-body-wrapper"
                  (click)="onNotificationOpen(notification)"
                  (keyup.enter)="onNotificationOpen(notification)"
                  (keyup.space)="onNotificationOpen(notification)"
                  tabindex="0"
                  role="button"
                >
                  <div class="notification-main">
                    <div class="notification-header-row">
                      @if (notification.notification_type === 17) {
                        <span class="admin-badge">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="9"
                            viewBox="0 0 640 640"
                          >
                            <path
                              d="M64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L360 512C354.8 512 349.8 513.7 345.6 516.8L230.4 603.2C226.2 606.3 221.2 608 216 608C202.7 608 192 597.3 192 584L192 512L160 512C107 512 64 469 64 416z"
                            />
                          </svg>
                          ADMIN
                        </span>
                      }
                      <h4 class="notification-title">
                        {{ notification.title }}
                      </h4>
                    </div>
                    <p class="notification-message">{{ notification.body }}</p>
                  </div>

                  <div class="notification-actions">
                    <span class="notification-time">{{
                      notification.created_on_utc | timeAgo
                    }}</span>
                    <button
                      type="button"
                      class="report-notification-btn"
                      title="Flag Notification"
                      (click)="onReportNotification(notification, $event)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                        ></path>
                        <line x1="4" y1="22" x2="4" y2="15"></line>
                      </svg>
                    </button>
                    <svg
                      class="chevron-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      width="12"
                      height="12"
                    >
                      <path
                        d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
                      />
                    </svg>
                  </div>
                </div>

                @if (!notification.is_read) {
                  <div class="unread-indicator"></div>
                }
              </div>
            }
          </div>
        </div>
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [totalItems]="totalNotifications"
          (pageChanged)="onPageChange($event)"
        ></app-pagination>
      } @else {
        <div class="no-data-wrapper">
          <div class="no-data">
            <div class="icon-holder">
              <app-svg-icon
                [iconName]="'no-data.svg'"
                [height]="'100px'"
                [width]="'100px'"
              ></app-svg-icon>
            </div>
            <div class="text-holder">No Data Available</div>
          </div>
        </div>
      }
    </div>
  </div>

  @if (showCDFIOutreachAcceptRejectPopup) {
    <app-popup
      [heading]="
        'Are you sure you want to ' +
        (isAcceptedCDFIOutreach ? 'accept' : 'reject') +
        ' this business as a lead?'
      "
      [confirmText]="'Yes'"
      [cancelText]="'Cancel'"
      (confirmClicked)="updateOutreachStatus()"
      (cancelClicked)="showCDFIOutreachAcceptRejectPopup = false"
    >
    </app-popup>
  }
} @else {
  <div class="mt-2">
    <app-skeleton type="notification-table"></app-skeleton>
  </div>
}

@if (showAnnouncementPopup && announcementId) {
  <app-secondary-popup
    [title]="'Announcement'"
    [isActionButtonsAvailable]="false"
    (popupClosed)="onAnnouncementPopupClose()"
  >
    <app-announcement-details
      [announcementId]="announcementId"
      (popupClosed)="onAnnouncementPopupClose()"
    ></app-announcement-details>
  </app-secondary-popup>
}

@if (showRecordDetails) {
  <app-record-details
    [unique_id]="uniqueId"
    [showNotes]="showNotes"
    (popupClosed)="showRecordDetails = false"
  ></app-record-details>
}

@if (showNotificationSettings) {
  <app-popup
    [heading]="'Notification Settings'"
    [confirmText]="'Save'"
    [cancelText]="'Cancel'"
    [showFooterButtons]="true"
    [showCloseIcon]="true"
    [isConfirmDisabled]="notificationSettings?.isLoading ?? true"
    (confirmClicked)="saveNotificationSettings()"
    (cancelClicked)="closeNotificationSettings()"
  >
    <app-notification-settings
      #notificationSettings
      (settingsSaved)="onSettingsSaved($event)"
      (settingsClosed)="closeNotificationSettings()"
    ></app-notification-settings>
  </app-popup>
}

@if (showBusinessDeletedPopup) {
  <app-popup
    [heading]="'Business Deleted'"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    (cancelClicked)="showBusinessDeletedPopup = false"
  >
    <div class="business-deleted-popup-content">
      <div class="info-row">
        <span class="label">Business Name</span>
        <span class="value">{{ selectedDeletedBusinessName }}</span>
      </div>
      <div class="info-row">
        <span class="label">Deleted Time</span>
        <span class="value">{{
          selectedDeletedBusinessTime | date: "medium"
        }}</span>
      </div>
    </div>
  </app-popup>
}
